// extracted by mini-css-extract-plugin
export default {"container":"nH-z","header":"oH-z","details":"pH-z","link":"qH-z"};